import {constructUsing} from 'rlink-collections/symbols';
import {isInstanceOrSubclassOf, isInstanceOf} from 'rlink-type-utils';

export default function setMemberCollectionsFactory (type, members, newInstance) {

  return {
    constructsUsing (obj) {
      if (isInstanceOrSubclassOf(obj, type)) {
        return constructUsing.both;
      } else {
        return this.NotApplicable;
      }
    },
    copyGenerator (obj, generatorFn) {
      if (isInstanceOf(obj, type)) {
        let iterable = generatorFn(
            this.yieldableFor(obj), this.entries(obj));
        let memberValues = {};
        for (let [name, val] of iterable) {
          memberValues[name] = val;
        }
        return newInstance(memberValues);
      } else {
        return this.NotApplicable;
      }
    },
    count (obj) {
      if (isInstanceOf(obj, type)) {
        return members.length;
      } else {
        return this.NotApplicable;
      }
    },
    *entries (obj) {
      if (isInstanceOf(obj, type)) {
        for (let member of members) {
          yield [member, obj[member]];
        }
      } else {
        return this.NotApplicable;
      }
    },
    hasKey (obj, key) {
      if (isInstanceOf(obj, type)) {
        return members.include(obj, key);
      } else {
        return this.NotApplicable;
      }
    },
    isIterable (obj) {
      return isInstanceOf(obj, type);
    },
    iterate (obj) {
      if (isInstanceOf(obj, type)) {
        return this.entries(obj);
      } else {
        return this.NotApplicable;
      }
    },
    keys (obj) {
      if (isInstanceOf(obj, type)) {
        return members;
      } else {
        return this.NotApplicable;
      }
    },
    valueForKey (obj, key) {
      if (isInstanceOf(obj, type)) {
        return obj[key];
      } else {
        return this.NotApplicable;
      }
    },
    *values (obj) {
      if (isInstanceOf(obj, type)) {
        for (let member of members) {
          yield obj[member];
        }
      } else {
        return this.NotApplicable;
      }
    },
  };

}



// WEBPACK FOOTER //
// ./lib/rlink-collections/setMemberCollectionsFactory.js